import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Collective } from './pages/Collective';
import { Buyers } from './pages/Buyers';
import { Sellers } from './pages/Sellers';
import { Contact } from './pages/Contact';
// Scroll to top on route change
const ScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Layout data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/collective" element={<Collective data-id="element-7" />} data-id="element-6" />
          <Route path="/buyers" element={<Buyers data-id="element-9" />} data-id="element-8" />
          <Route path="/sellers" element={<Sellers data-id="element-11" />} data-id="element-10" />
          <Route path="/contact" element={<Contact data-id="element-13" />} data-id="element-12" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}